module.exports = "/_next/static/images/photoAlexandruBacinschii-ccb6a9bab467cc71624bb2e86d982fd0.webp";